module.exports = __webpack_public_path__ + "static/media/energy-ratings.b498f7f8.svg";